import React, { useEffect } from "react";
import { Auth0Provider, useAuth0 } from "@auth0/auth0-react";
// @ts-ignore
import EventBus from "react-native-event-bus";
import Constants from "@lib/utilities/Constants";

let logoutFunction: (() => void) | null = null;

export const setLogoutFunction = (logout: () => void) => {
  logoutFunction = logout;
};

export const performLogout = () => {
  if (logoutFunction) {
    logoutFunction();
  }
};

const AuthProvider = ({ children }: any) => {
  const { logout } = useAuth0();

  useEffect(() => {
    setLogoutFunction(logout);
  }, [logout]);

  return (
    <Auth0Provider
      domain={process.env.REACT_APP_EXZEO_ID_DOMAIN ?? ""}
      clientId={process.env.REACT_APP_EXZEO_ID_CLIENT_ID ?? ""}
      authorizationParams={{
        scope: "openid email profile offline_access",
        redirect_uri: window?.location?.origin + "/login",
      }}
      onRedirectCallback={onRedirectCallback}
      cacheLocation="localstorage"
      useRefreshTokens={true}
    >
      <>{children}</>
    </Auth0Provider>
  );
};
const onRedirectCallback = () => {
  EventBus.getInstance().fireEvent(Constants.Events.LOGIN_SUCCESS, "LOGIN");
};

export default AuthProvider;
